<template>
  <div class="ym-iframe-page">
    <ym-iframe class="ym-iframe"
               :src="pageUrl"
    />
    <contact-info :wx-path="contactInfo.wxSrc"
                  :mini-path="contactInfo.miniSrc"
    />
  </div>
</template>

<script>
  import YmIframe from '@/components/YmIframe';
  import ContactInfo from '@/components/YmPcContactInfo';

  export default {
    name: 'YmIframePage',
    components: {
      YmIframe,
      ContactInfo,
    },
    props: {
      pageUrl: {
        type: String,
        required: true,
      },
      contactInfo: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .ym-iframe-page {
    width: 100%;
    height: 100%;
    background: #fff;
  }

  /deep/ .ym-iframe {
    overflow: hidden;
    height: 100%;
  }

</style>
